import { render, staticRenderFns } from "./LandingQuestions.vue?vue&type=template&id=209a444a&scoped=true"
import script from "./LandingQuestions.vue?vue&type=script&lang=js"
export * from "./LandingQuestions.vue?vue&type=script&lang=js"
import style0 from "./LandingQuestions.vue?vue&type=style&index=0&id=209a444a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209a444a",
  null
  
)

export default component.exports